import axios, { AxiosRequestConfig }  from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ISetupTtsPayload,
  IFetchProjectVersionSettingsTtsPayload,
  IFetchTranslationLanguagesTtsPayload,
} from './types'

export function fetchProjectVersionSettingsTts(payload: IFetchProjectVersionSettingsTtsPayload) {
  return axios.get('/api/v1/project_versions/show_settings_tts', { params: convertToSnakeCase(payload) })
}

export function setupTts(payload: ISetupTtsPayload) {
  const config: AxiosRequestConfig = {
    responseType: 'json'
  }

  return axios.put('/api/v1/project_versions/setup_tts', convertToSnakeCase(payload), config)
}

export function fetchTranslationLanguagesTts(payload: IFetchTranslationLanguagesTtsPayload) {
  return axios.get('/api/v1/project_versions/show_translation_languages_language_wire', { params: convertToSnakeCase(payload) })
}
